import MemriseApi from '../MemriseApi';
import { LearnableResponse, LearnableScenariosResponse } from './schema';

export default class LearnablesApiClass extends MemriseApi {
  constructor() {
    super({ endpointPrefix: '/learnable_details' });
  }

  public async getLearnable(learnableId: string): Promise<LearnableResponse> {
    return await this.get(`/${learnableId}/`);
  }

  public async getLearnableScenarios(learnableId: string): Promise<LearnableScenariosResponse> {
    return await this.get(`/${learnableId}/scenarios/`);
  }
}

export const LearnablesApi = new LearnablesApiClass();
